<template>
  <div>
    <Head />

    <nav class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">{{ $t('首頁') }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('學人宿舍借住申請書') }}</li>
      </ol>
    </nav>

    <!-- 20240923 新增class form -->
    <div class="wrapper list_1 form_2_list form">
      <svg class="bg"></svg>
      <!-- 圖文列表 -->
      <section class="">
        <div class="container">
          <!-- 20240923 新增 box_bg -->
          <div class="list_box box_bg">
            <div class="title_box">
              <h1>{{ $t('學人宿舍/五棟房') }}</h1>
            </div>
            <!-- 20240923 新增 日期區間 -->
            <div class="box">
              <div class="form-group date_box full">
                <label>{{ $t('借住期間') }}</label>
                <input type="text" id="rangeDate" class="form-control" :placeholder="$t('請輸入住宿日期')" data-input
                  v-model="RangeTime">
              </div>
            </div>
            <ul class="list">
              <li v-for="ScholarBuilding in ScholarBuildings" :key="ScholarBuilding.SBId">
                <slick class="img_list" v-if="ScholarBuilding.Slideshow">
                  <div class="img_box" v-for="(Slideshow, index) in JSON.parse(ScholarBuilding.Slideshow)" :key="index">
                    <img :src="BuildingData.SiteUrl + Slideshow.Url" :alt="Slideshow.DisplayName" />
                  </div>
                </slick>
                <div class="text_box">
                  <!-- 20240923 刪掉a連結 -->
                  <!-- <a href=""> -->
                  <div class="text">
                    <h1>
                      <div class="tag">{{ ScholarBuilding.Space == 1 ? $t('單房間') : $t('多房間') }}</div>{{ local == "zh_tw"
                        ? ScholarBuilding.Name : ScholarBuilding.Name_EN }}
                    </h1>
                    <p v-html="local == 'zh_tw' ? ScholarBuilding.Content : ScholarBuilding.Content_EN"></p>
                  </div>
                  <div class="btn_box" v-if="ScholarBuilding.ScholarRooms.length == 0">
                    <div class="box room_box">
                      <div class="form-group full">
                        <label>{{ $t('房間') }}</label>
                        <select class="form-control" disabled>
                          <option selected disabled>{{ $t('滿房') }}</option>
                        </select>
                      </div>
                    </div>
                    <button class="next_btn">{{ $t('立即申請') }}</button>
                  </div>
                  <div class="btn_box" v-if="ScholarBuilding.ScholarRooms.length > 0">
                    <div class="box room_box">
                      <div class="form-group full">
                        <label>{{ $t('房間') }}</label>
                        <select class="form-control" v-model="ScholarBuilding.SCRId">
                          <option value="-1" selected>{{ $t('請選擇') }}</option>
                          <option v-for="ScholarRoom in ScholarBuilding.ScholarRooms" :key="ScholarRoom.SCRId"
                            :value="ScholarRoom.SCRId">
                            {{ ScholarRoom.RoomId }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <button class="next_btn" @click="gotoApply(ScholarBuilding.SCRId)">{{ $t('立即申請') }}</button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

import Slick from "vue-slick";

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "學人宿舍借住申請書": "學人宿舍借住申請書",
    "學人宿舍/五棟房": "學人宿舍/五棟房",
    "借住期間": "借住期間",
    "請輸入住宿日期": "請輸入住宿日期",
    "單房間": "單房間",
    "多房間": "多房間",
    "房間": "房間",
    "滿房": "滿房",
    "立即申請": "立即申請",
    "請選擇": "請選擇",
    "請先登入帳號": "請先登入帳號",
    "錯誤": "錯誤",
    "確定": "確定",
    "請選擇借住期間": "請選擇借住期間",
    "請選擇房間": "請選擇房間",
    "請選擇完整的日期範圍": "請選擇完整的日期範圍",
  },
  en: {
    "首頁": "Home Page",
    "學人宿舍借住申請書": "Application form for Visiting Scholars Dormitory Rental",
    "學人宿舍/五棟房": "Visiting Scholars Dormitory/ 5 Buildings",
    "借住期間": "Duration of Stay",
    "請輸入住宿日期": "Please enter the date of staying",
    "單房間": "Single-room",
    "多房間": "Multi-room",
    "房間": "Rooms",
    "滿房": "Full occupancy",
    "立即申請": "Apply now",
    "請選擇": "Please select",
    "請先登入帳號": "Please log in first",
    "錯誤": "Error",
    "確定": "Confirm",
    "請選擇借住期間": "Please select the duration of staying",
    "請選擇房間": "Please select the room",
    "請選擇完整的日期範圍": "Please select a complete date range",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Building",
  i18n,
  components: {
    Head,
    Footer,
    Slick
  },
  data() {
    return {
      BuildingData: {},
      ScholarBuildings: [],
      pageAll: 0,
      perPage: 10,
      local: "zh_tw",
      RangeTime: '',
      StartTime: '',
      EndTime: '',
    };
  },
  watch: {
    RangeTime: {
      handler(newVal, oldVal) {
        // 檢查是否為有效的日期範圍格式，flatpickr 範圍模式會以 " to " 分隔兩個日期
        if (newVal && newVal.includes(' 至 ')) {
          this.loadList(1);
        }
      }
    },
  },
  beforeCreate: function () {
    if (!$cookies.isKey("dormitory_login_token")) {
      Swal.fire({
        title: this.$t("請先登入帳號"),
        icon: "info",
        allowOutsideClick: false,
        heightAuto: false,
        willClose: () => {
          this.$router.push({
            name: "Home",
          });
        },
      });
      return;
    }
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/Building",
        {
          params: {},
        }
      )
      .then((response) => {
        this.BuildingData = response.data;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
    
    let that = this;
    $("#rangeDate").flatpickr({
      mode: 'range',
      dateFormat: "Y-m-d",
      // inline: true,
      minDate: "today",
      "locale": "zh_tw",
      onClose: function(selectedDates, dateStr, instance) {
        // 檢查是否選擇了完整的日期範圍
        if (selectedDates.length === 1) {
          // 只選擇了一個日期，清空輸入欄位
          instance.clear();
          that.RangeTime = '';
          // 顯示提示訊息
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("請選擇完整的日期範圍"),
            icon: "warning",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
        } else if (selectedDates.length === 2) {
          // 選擇了完整的日期範圍，正常處理
          that.RangeTime = dateStr;
        }
      }
    });
  },
  updated: function () {
  },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          this.$store.state.src +
          this.$store.state.subDirectory +
          "/Html/BuildingList",
        type: "post",
        data: {
          RangeTime: that.RangeTime,
          page: page,
          perPage: that.perPage,
          token: $cookies.get("dormitory_login_token"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.ScholarBuildings = res.ScholarBuildings;
            that.StartTime = res.StartTime ? res.StartTime : '';
            that.EndTime = res.EndTime ? res.EndTime : '';
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            document.body.scrollTop = 0;
          }
        },
      });
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    numberToCurrencyNo(value) {
      if (!value) return 0
      const intPart = Math.trunc(value)
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      let floatPart = ''
      const valueArray = value.toString().split('.')
      if (valueArray.length === 2) {
        floatPart = valueArray[1].toString()
        return intPartFormat + '.' + floatPart
      }
      return intPartFormat + floatPart
    },
    gotoApply(SCRId) {
      let that = this;
      if (!that.RangeTime) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請選擇借住期間"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        return false;
      }
      if (that.RangeTime && !that.RangeTime.includes(' 至 ')) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請選擇完整的日期範圍"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        return false;
      }
      if (SCRId == -1) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請選擇房間"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        return false;
      }
      // 轉移      
      that.$router.push({
        name: "Apply_2",
        params: { StartTime: that.StartTime, EndTime: that.EndTime, SCRId: SCRId },
      });
    }
  },
};
</script>
